import styled from "styled-components";
import { BodyDefault } from "../../components/typography/styled";

export const Container = styled.div`
  padding: 10px 30px 10px 20px;

  @media screen and (max-width: 768px) {
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    padding: 10px 16px 32px;
  }
`
export const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 768px) {
    width: 100%;
    min-width: 0;

    > img {
      width: 100%;
      max-width: 640px;
      height: auto;
    }
  }
`

export const TextWrapper = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
  margin-top:60px;

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    margin-top: 32px;
  }
`
export const GreyText = styled(BodyDefault)`
  color:${({theme}) => theme.palette[650]};
  margin:20px 0px;
`

export const BlueText = styled(BodyDefault)`
  color:${({theme}) => theme.primary[600]};
`

export const LinkWrapper = styled.div`
  display: flex;
  gap:10px;
  margin-top: 20px;
  &:hover {
    cursor:pointer;
  }
`
